
export const fupUpdateEndpoints = (builder) => ({
  // GET - fup/policies list with pagination & filters
  getFupPolicies: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 25,
        searchColumn,
        searchValue,
        fromFupDate,
        toFupDate,
        sortField,
        sortOrder,
        fetchAll,
      } = args;

      const params = { pageNumber, pageSize };
      if (searchColumn !== undefined && searchColumn !== null) params.searchColumn = searchColumn;
      if (searchValue !== undefined && searchValue !== null) params.searchValue = searchValue;
      if (fromFupDate) params.fromFupDate = fromFupDate;
      if (toFupDate) params.toFupDate = toFupDate;
      if (sortField) params.sortField = sortField;
      if (sortOrder) params.sortOrder = sortOrder;
      if (fetchAll !== undefined) params.fetchAll = fetchAll;

      return {
        // backend route for FUP list is mounted under /Fup-operations
        url: '/Fup-operations/fup-getlist',
        method: 'GET',
        params,
      };
    },

    // tolerant transformResponse: supports
    // 1) { data: [...], totalCount: N } (preferred)
    // 2) debug shape { rawRecordsets: [ rowsArray, [ { TotalCount } ] ] }
    // 3) direct mssql result with `recordsets`
    // 4) raw array (server returned array directly)
    transformResponse: (response) => {
      // default fallbacks
      let data = [];
      let totalCount = 0;

      // case A: already a normalized payload { data, totalCount }
      if (response && (Array.isArray(response.data) || typeof response.totalCount !== 'undefined')) {
        data = Array.isArray(response.data) ? response.data : [];
        totalCount = Number(response.totalCount ?? (Array.isArray(data) ? data.length : 0));
      } else {
        // case B: debug rawRecordsets (your current curl shows rawRecordsets)
        const raw = response?.rawRecordsets ?? response?.recordsets ?? null;

        if (Array.isArray(raw) && Array.isArray(raw[0])) {
          data = raw[0];
          // try to read TotalCount from second recordset
          if (Array.isArray(raw[1]) && raw[1][0] && typeof raw[1][0].TotalCount !== 'undefined') {
            totalCount = Number(raw[1][0].TotalCount);
          } else {
            totalCount = Array.isArray(data) ? data.length : 0;
          }
        } else if (Array.isArray(response)) {
          // case C: server returned array directly
          data = response;
          totalCount = data.length;
        } else {
          // final fallback: try response.data again or empty
          data = Array.isArray(response?.data) ? response.data : [];
          totalCount = Number(response?.totalCount ?? (Array.isArray(data) ? data.length : 0));
        }
      }

      return {
        data,
        totalCount: Number(totalCount ?? 0),
        success: !!response?.success,
        message: response?.message ?? '',
      };
    },

    providesTags: (result) => {
      if (!result || !Array.isArray(result.data)) return ['Policy'];
      const tags = result.data
        .map((p) => {
          const id = p?.PolicyID ?? p?.PolicyId ?? p?.PolicyNo ?? null;
          return id ? { type: 'Policy', id } : null;
        })
        .filter(Boolean);
      return [...tags, { type: 'Policy', id: 'LIST' }]; 
    },
  }),
 
  // POST - batch update FUP
  batchUpdateFup: builder.mutation({
    query: (payload) => ({
      // backend route for batch update
      url: '/Fup-operations/batch-fup-update',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: [{ type: 'Policy', id: 'LIST' }],
  }),

  deletePolicy: builder.mutation({
    query: (id) => ({ url: `/policies/${id}`, method: 'DELETE' }),
    invalidatesTags: [{ type: 'Policy', id: 'LIST' }],
  }),

  bulkDeletePolicy: builder.mutation({
    query: (payload) => ({ url: '/policies/bulk-delete', method: 'POST', body: payload }),
    invalidatesTags: [{ type: 'Policy', id: 'LIST' }],
  }),
});

